import React from 'react';
import classNames from 'classnames';
import { usePuppyGuide } from './PuppyGuideContext';
import SubNav from './SubNav';
import './sticky-header.scss';

const StickyHeader = () => {
  const { isHeaderSticky, stickyHeaderTopOffset } = usePuppyGuide();
  const className = classNames('starter-guide-sticky-header', {
    'starter-guide-sticky-header--no-size': !isHeaderSticky,
  });
  return (
    <div
      className={className}
      style={{ top: stickyHeaderTopOffset }}
      data-testid={isHeaderSticky ? 'starter-guide-sticky-header' : null}
      aria-hidden={!isHeaderSticky}
    >
      <SubNav isSticky={true} isDisplayed={isHeaderSticky} />
    </div>
  );
};

export default StickyHeader;
